module.exports = __webpack_public_path__ + "img/tips1_botlist1img5.63fb10c9.jpg";